import { render, staticRenderFns } from "./TaskRawDetail.vue?vue&type=template&id=50a65eba&scoped=true"
import script from "./TaskRawDetail.vue?vue&type=script&lang=js"
export * from "./TaskRawDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskRawDetail.vue?vue&type=style&index=0&id=50a65eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a65eba",
  null
  
)

export default component.exports